import {map} from 'lodash/fp';
import {seatClasses} from 'helpers/stableValues';

const seatClassOptions = map.convert({cap: false})((val, text) => ({text, val}), seatClasses);

export default seatClassOptions;